import React, { useEffect, useState } from 'react'
import Chart from '../components/charts'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import TransitionalModal from "../components/transitional";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BURL } from '../../../services/base';
import { formatDateTime } from '../../../utils/common.utils';

function createData(
    name,
    calories,
    fat,
    carbs,
    protein,
) {
    return { name, calories, fat, carbs, protein };
}

export default function Home() {
    const [dashSummary, setDashSummary] = useState([]);
    const [payments, setPayments] = useState([]);
    const [error, setError] = useState(null);

    const fetchDashboardSummary = async (tenantRoomId) => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${BURL}/admin/dashboard`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            const dash_summary = await response.data.data;
            if (dash_summary?.recentPayments) {
                setPayments(dash_summary.recentPayments)
            } else {
                setPayments([]);
            }
            setDashSummary(dash_summary);
        } catch (err) {
            setError(err);
        }
    };

    useEffect(() => {
        fetchDashboardSummary();
    }, []);

    return (
        <React.Fragment>
            <div className="md:px-10 sm:px-3 mt-5 md:mt-6 flex justify-end items-center pt-3 bg-white mb-0">
                {/* <h1 className="font-bold">  Dashboard</h1> */}
                <TransitionalModal />
            </div>
            <div className='w-full bg-white'>
                {/* Property section */}
                <div className="px-[1.22rem] md:px-[1.8em] bg-white w-full mb-10">
                    {/* <div className='pb-10 w-full'> */}
                    <p className='mb-5 text-[#2DB46D] text-[16px] md:text-[16px] font-semibold'>Properties Overview</p>
                    <div className='flex flex-col md:flex-row md:flex-wrap lg:flex-nowrap md:jsutify-between gap-5 lg:mx-0'>
                        <Link to="/dashboard/properties" className='bg-[#EADAFF] px-6 py-2 h-[160px] w-full md:w-[48%] xl:w-1/3 rounded-md text-[#6C6C6C] flex flex-col gap-4 cursor-pointer'>
                            <span className='text-[14px]'>No. of Properties</span>
                            <div className='flex justify-between'>
                                <p className='flex flex-col mt-2 md:mt-1'>
                                    <span className='text-[40px] md:text-[45px] font-semibold'>{dashSummary?.propertyCount}</span>
                                    <span className='text-[16px] -mt-2 md:-mt-1 font-semibold'>Properties</span>
                                </p>
                                <div>
                                    <img src="/mdi_home.png" className='' alt="" />
                                </div>
                            </div>
                        </Link>

                        <Link to="dashboard/properties" className='bg-[#CFEEDE] px-6 py-2 h-[160px] w-full md:w-[48%] xl:w-1/3 rounded-md text-[#6C6C6C] flex flex-col gap-4 cursor-pointer'>
                            <span className='text-[14px]'>Active Leases</span>
                            <div className='flex justify-between'>
                                <p className='flex flex-col mt-2 md:mt-1'>
                                    <span className='text-[40px] md:text-[45px] font-semibold'>{dashSummary?.activeLeasesCount}</span>
                                    <span className='text-[16px] -mt-2 md:-mt-1 font-semibold'>Active leases</span>
                                </p>
                                <div>
                                    <img src="/lease.png" className='' alt="" />
                                </div>
                            </div>
                        </Link>

                        <Link to="dashboard/properties" className='bg-[#CDE2FB] px-6 py-2 h-[160px] w-full md:w-[48%] xl:w-1/3 rounded-md text-[#6C6C6C] flex flex-col gap-4 cursor-pointer'>
                            <span className='text-[14px]'>Upcoming Renewals</span>
                            <div className='flex justify-between'>
                                <p className='flex flex-col mt-2 md:mt-1'>
                                    <span className='text-[40px] md:text-[45px] font-semibold'>{dashSummary?.endingLeasesIn90days}</span>
                                    <span className='text-[16px] -mt-2 md:-mt-3 font-semibold'>Leases ending &lt;=90 days</span>
                                    {/* <span className='text-[16px] -mt-2 md:-mt-1'>Ending Lease</span> */}
                                </p>
                                <div>
                                    <img src="/end-lease.png" className='' alt="" />
                                </div>
                            </div>
                        </Link>

                        <Link to="dashboard/properties" className='bg-[#EB042D33] px-6 py-2 h-[160px] w-full md:w-[48%] xl:w-1/3 rounded-md text-[#6C6C6C] flex flex-col gap-4 cursor-pointer'>
                            <span className='text-[14px]'>Delinquencies</span>
                            <div className='flex justify-between'>
                                <p className='flex flex-col mt-2 md:mt-1'>
                                    <span className='text-[40px] md:text-[45px] font-semibold'>{dashSummary?.delinquencies}</span>
                                    <span className='text-[16px] -mt-2 md:-mt-1 font-semibold'>Overdue Payments</span>
                                </p>
                                <div>
                                    <img src="/delinquencies.png" className='' alt="" />
                                </div>
                            </div>
                        </Link>
                    </div>
                    {/* </div> */}
                </div>
                {/* Chart section */}
                <div className='w-full px-[1.22rem] md:px-[1.8em] flex flex-col md:flex-row gap-10 mb-10'>
                    <div className="w-full md:w-3/5 lg:w-2/3 bg-white shadow-lg rounded-lg px-6 py-3">
                        <p className='text-[#2DB46D] text-[16px] md:text-[16px] font-semibold'>Income Analytics</p>
                        <div className='p-5'>
                            <Chart />
                        </div>
                    </div>
                    {/* Tenant Complaints */}
                    <div className="w-full md:w-2/5 lg:w-1/3 bg-white shadow-lg rounded-lg px-4 py-3">
                        <div className='flex justify-between'>
                            <p className='text-[#2DB46D] text-[16px] md:text-[16px] font-semibold'>Tenant Requests</p>
                            <Link className='text-[#6C6C6C] text-[12px] md:text-[14px] mt-2'>View all</Link>
                        </div>
                        <div className="flex flex-col gap-10 justify-center items-center mx-auto py-10 md:py-20">
                            <img src="/empty.svg" alt="" className='w-[150px]' />
                            No tenant requests yet
                        </div>

                        {/* <div className='flex flex-col gap-5 mt-4'>

                            <div className='flex justify-between'>
                                <div className='flex gap-3'>
                                    <img src="/avatar.png" className='rounded-full h-[50px]' alt="" />
                                    <div className='flex flex-col gap-0 lg:gap-1 text-[#6C6C6C]'>
                                        <h3 className='text-[14px] lg:text-[16px] font-semibold'>Funke Orimolade</h3>
                                        <p className='text-[12px] lg:text-[14px]'>Abraham Adesanya Hostel <span className='text-[8px] lg:text-[10px] font-bold'>.</span> Aug 22, 2022 </p>
                                    </div>
                                </div>
                                <PlayArrowIcon className='flex items-center ml-9 mt-2 cursor-pointer text-[#6C6C6C]' />
                            </div>

                            <div className='flex justify-between'>
                                <div className='flex gap-3'>
                                    <img src="/avatar.png" className='rounded-full h-[50px]' alt="" />
                                    <div className='flex flex-col gap-0 lg:gap-1 text-[#6C6C6C]'>
                                        <h3 className='text-[14px] lg:text-[16px] font-semibold'>Funke Orimolade</h3>
                                        <p className='text-[12px] lg:text-[14px]'>Abraham Adesanya Hostel <span className='text-[8px] lg:text-[10px] font-bold'>.</span> Aug 22, 2022 </p>
                                    </div>
                                </div>
                                <PlayArrowIcon className='flex items-center ml-9 mt-2 cursor-pointer text-[#6C6C6C]' />
                            </div>

                            <div className='flex justify-between'>
                                <div className='flex gap-3'>
                                    <img src="/avatar.png" className='rounded-full h-[50px]' alt="" />
                                    <div className='flex flex-col gap-0 lg:gap-1 text-[#6C6C6C]'>
                                        <h3 className='text-[14px] lg:text-[16px] font-semibold'>Funke Orimolade</h3>
                                        <p className='text-[12px] lg:text-[14px]'>Abraham Adesanya Hostel <span className='text-[8px] lg:text-[10px] font-bold'>.</span> Aug 22, 2022 </p>
                                    </div>
                                </div>
                                <PlayArrowIcon className='flex items-center ml-9 mt-2 cursor-pointer text-[#6C6C6C]' />
                            </div>

                            <div className='flex justify-between'>
                                <div className='flex gap-3'>
                                    <img src="/avatar.png" className='rounded-full h-[50px]' alt="" />
                                    <div className='flex flex-col gap-0 lg:gap-1 text-[#6C6C6C]'>
                                        <h3 className='text-[14px] lg:text-[16px] font-semibold'>Funke Orimolade</h3>
                                        <p className='text-[12px] lg:text-[14px]'>Abraham Adesanya Hostel <span className='text-[8px] lg:text-[10px] font-bold'>.</span> Aug 22, 2022 </p>
                                    </div>
                                </div>
                                <PlayArrowIcon className='flex items-center ml-9 mt-2 cursor-pointer text-[#6C6C6C]' />
                            </div>

                            <div className='flex justify-between'>
                                <div className='flex gap-3'>
                                    <img src="/avatar.png" className='rounded-full h-[50px]' alt="" />
                                    <div className='flex flex-col gap-0 lg:gap-1 text-[#6C6C6C]'>
                                        <h3 className='text-[14px] lg:text-[16px] font-semibold'>Funke Orimolade</h3>
                                        <p className='text-[12px] lg:text-[14px]'>Abraham Adesanya Hostel <span className='text-[8px] lg:text-[10px] font-bold'>.</span> Aug 22, 2022 </p>
                                    </div>
                                </div>
                                <PlayArrowIcon className='flex items-center ml-9 mt-2 cursor-pointer text-[#6C6C6C]' />
                            </div>

                            <div className='flex justify-between'>
                                <div className='flex gap-3'>
                                    <img src="/avatar.png" className='rounded-full h-[50px]' alt="" />
                                    <div className='flex flex-col gap-0 lg:gap-1 text-[#6C6C6C]'>
                                        <h3 className='text-[14px] lg:text-[16px] font-semibold'>Funke Orimolade</h3>
                                        <p className='text-[12px] lg:text-[14px]'>Abraham Adesanya Hostel <span className='text-[8px] lg:text-[10px] font-bold'>.</span> Aug 22, 2022 </p>
                                    </div>
                                </div>
                                <PlayArrowIcon className='flex items-center ml-9 mt-2 cursor-pointer text-[#6C6C6C]' />
                            </div>
                        </div> */}
                    </div>
                </div>
                {/* Recent Payments */}
                <div className='w-full px-[1.22rem] md:px-[1.8em] flex flex-col md:flex-row gap-10'>
                    <div className="w-full bg-white shadow-lg rounded-lg px-6 py-3">
                        <div className='flex justify-between'>
                            <p className='text-[#2DB46D] text-[16px] font-semibold'>Recent Payments</p>
                            <Link className='text-[#6C6C6C] text-[12px] md:text-[14px] mt-2'>View all</Link>
                        </div>

                        <TableContainer className='mt-4' component={Paper} style={{ border: 0, backgroundColor: 'transparent', boxShadow: 'none'}}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table" style={{ border: 0, backgroundColor: 'transparent' }}>
                                <TableHead >
                                    <TableRow style={{ borderBottom: 0 }}>
                                        <TableCell style={{ borderBottom: 0, fontSize: '16px', color: '#6C6C6C', fontWeight: 'bold' }}>Transaction ID</TableCell>
                                        <TableCell style={{ borderBottom: 0, fontSize: '16px', color: '#6C6C6C', fontWeight: 'bold' }}>Name</TableCell>
                                        <TableCell style={{ borderBottom: 0, fontSize: '16px', color: '#6C6C6C', fontWeight: 'bold' }}>Amount</TableCell>
                                        <TableCell style={{ borderBottom: 0, fontSize: '16px', color: '#6C6C6C', fontWeight: 'bold' }}>Date/Time</TableCell>
                                        {/* <TableCell style={{ borderBottom: 0, fontSize: '16px' }}></TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody style={{ borderBottom: 0, fontSize: '16px' }}>
                                    {payments.map((payment) => (
                                        <TableRow
                                            key={payment.id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell style={{ borderBottom: 0, fontSize: '16px', color: '#6C6C6C' }} component="th" scope="row">
                                                {payment.ref}
                                            </TableCell>
                                            <TableCell style={{ borderBottom: 0, fontSize: '16px', color: '#6C6C6C' }} className='capitalize'>{payment?.invoice?.tenantRoom?.tenant?.user?.firstname} <span className='capitalize'>{payment?.invoice?.tenantRoom?.tenant?.user?.lastname}</span></TableCell>
                                            <TableCell style={{ borderBottom: 0, fontSize: '16px', color: '#6C6C6C' }}>{payment.amount}</TableCell>
                                            <TableCell style={{ borderBottom: 0, fontSize: '16px', color: '#6C6C6C' }}>{formatDateTime(payment.date)}</TableCell>
                                            {/* <TableCell style={{ borderBottom: 0, fontSize: '16px' }} align="right"><PlayArrowIcon className='flex items-center ml-9 cursor-pointer text-[#6C6C6C]' /></TableCell> */}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}